import React from 'react';

const Stepper = ({ text, isActive, isDone, stepNumber }) => {
  const stepperClassName = isActive ? 'stepper-text--active' : 'stepper-text';
  const rootClassName = [
    'stepper',
    isActive ? 'stepper--active' : '',
    isDone ? 'stepper--done' : '',
  ]
    .filter(Boolean)
    .join(' ');
  const indicatorClassName = isDone
    ? 'stepper__indicator stepper__indicator--done'
    : 'stepper__indicator';

  return (
    <div className={rootClassName}>
      <div className={indicatorClassName}>
        {isDone ? (
          <span className="material-icons stepper__icon">done</span>
        ) : (
          stepNumber && <span className="stepper__number">{stepNumber}</span>
        )}
      </div>
      <div className={stepperClassName}>{text}</div>
    </div>
  );
};
export default Stepper;
